import { Category } from '../models';
import sermonJson from '../data/allSermonData.json';

export const allSermonData: { [categoryName: string]: Category } = sermonJson;
